import React from 'react';
import './AboutPage.css';
import About from '../../components/About/About';
import MissionValues from '../../components/MissionValues/MissionValues';
import DepartmentHead from '../../components/DepartmentHead/DepartmentHead';

function AboutPage() {
    return (
        <div className="App">
            <About />
            <MissionValues />
            <DepartmentHead />
        </div>
    );
}

export default AboutPage;
